import { P2GText } from '@parcel2go/core-ui';
import { Customer } from '~/lib/api/smartsend/types';

interface props {
  customer: Customer;
}

export function CustomerAddressStr(customer: Customer) {
  return `${customer.AddressLine1} ${customer.AddressLine2}, ${customer.Postcode}`;
}

export default function CustomerAddress(props: props) {
  if (!props.customer) {
    return null;
  }
  return <P2GText data-sentry-mask>{CustomerAddressStr(props.customer)}</P2GText>;
}
